// configApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

type ConfigData = {
  currentEmployee?: Employee;
  effective_role: "employee" | "manager" | "owner" | null;
  ENABLE_TRACKING: boolean;
  SENTRY_CLIENT_DSN: string;
  TEAMUP_READ_CALENDAR_KEY: string;
  debug: boolean;
  version: string;
};

export const configApi = createApi({
  reducerPath: "configApi",
  // Skipped using custom baseQuery to avoid circular dependency
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    setDevAdminMode: builder.mutation<{ effective_role: ConfigData["effective_role"] }, boolean>({
      query: (enabled) => ({
        url: "/api/dev_admin_mode",
        method: "PUT",
        body: { enabled },
      }),
    }),
    getConfig: builder.query<ConfigData, void>({
      query: () => "/api/config",
    }),
  }),
});

export const { useGetConfigQuery, useSetDevAdminModeMutation } = configApi;
